'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

var createStyleElement = function createStyleElement(className) {
  var style = _globalDocument2['default'].createElement('style');
  style.className = className;

  return style;
};

exports.createStyleElement = createStyleElement;
var setTextContent = function setTextContent(el, content) {
  if (el.styleSheet) {
    el.styleSheet.cssText = content;
  } else {
    el.textContent = content;
  }
};
exports.setTextContent = setTextContent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9qcy91dGlscy9zdHlsZXNoZWV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs4QkFBcUIsaUJBQWlCOzs7O0FBRS9CLElBQUksa0JBQWtCLEdBQUcsU0FBckIsa0JBQWtCLENBQVksU0FBUyxFQUFFO0FBQ2xELE1BQUksS0FBSyxHQUFHLDRCQUFTLGFBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUM1QyxPQUFLLENBQUMsU0FBUyxHQUFHLFNBQVMsQ0FBQzs7QUFFNUIsU0FBTyxLQUFLLENBQUM7Q0FDZCxDQUFDOzs7QUFFSyxJQUFJLGNBQWMsR0FBRyxTQUFqQixjQUFjLENBQVksRUFBRSxFQUFFLE9BQU8sRUFBRTtBQUNoRCxNQUFJLEVBQUUsQ0FBQyxVQUFVLEVBQUU7QUFDakIsTUFBRSxDQUFDLFVBQVUsQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDO0dBQ2pDLE1BQU07QUFDTCxNQUFFLENBQUMsV0FBVyxHQUFHLE9BQU8sQ0FBQztHQUMxQjtDQUNGLENBQUMiLCJmaWxlIjoic3JjL2pzL3V0aWxzL3N0eWxlc2hlZXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZG9jdW1lbnQgZnJvbSAnZ2xvYmFsL2RvY3VtZW50JztcblxuZXhwb3J0IGxldCBjcmVhdGVTdHlsZUVsZW1lbnQgPSBmdW5jdGlvbihjbGFzc05hbWUpIHtcbiAgbGV0IHN0eWxlID0gZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgnc3R5bGUnKTtcbiAgc3R5bGUuY2xhc3NOYW1lID0gY2xhc3NOYW1lO1xuXG4gIHJldHVybiBzdHlsZTtcbn07XG5cbmV4cG9ydCBsZXQgc2V0VGV4dENvbnRlbnQgPSBmdW5jdGlvbihlbCwgY29udGVudCkge1xuICBpZiAoZWwuc3R5bGVTaGVldCkge1xuICAgIGVsLnN0eWxlU2hlZXQuY3NzVGV4dCA9IGNvbnRlbnQ7XG4gIH0gZWxzZSB7XG4gICAgZWwudGV4dENvbnRlbnQgPSBjb250ZW50O1xuICB9XG59O1xuIl19